import {
  useSearchDateShortcut,
  useSearchDays,
  useSearchDuration
} from '@/hooks/useSearch'
import { secondToString } from '@/utils/date-format'
import type {
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type { StatisticalEventRecord } from './statistical-event.service'

export function createStatisticalEventSearchItems(
  channelOptions: CrudSelectOption[],
  optionsLoading: boolean
): CrudSearchItem[] {
  const controlClass = 'statistical-event-page__search-control'

  return [
    {
      label: '直播间',
      prop: 'channelId',
      type: 'select',
      controlClass,
      clearable: true,
      loading: optionsLoading,
      placeholder: '请选择直播间',
      options: channelOptions
    },
    {
      label: '访问时间',
      prop: 'accessTime',
      type: 'dateTimeRange',
      controlClass,
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      shortcuts: useSearchDateShortcut(),
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间',
      disabledDate: (date) => date.getTime() > Date.now()
    },
    {
      label: '访问时长',
      prop: 'duration',
      type: 'select',
      controlClass,
      clearable: true,
      placeholder: '请选择访问时长',
      options: useSearchDuration().map((item) => ({
        label: item.title,
        value: item.value
      }))
    },
    {
      label: '持续听课且未成交',
      prop: 'continueAttend',
      type: 'select',
      controlClass,
      clearable: true,
      placeholder: '请选择天数',
      options: useSearchDays().map((item) => ({
        label: item.title,
        value: item.value
      }))
    }
  ]
}

export const statisticalEventTableColumns: CrudTableColumn<StatisticalEventRecord>[] =
  [
    {
      prop: 'channelName',
      label: '直播间',
      minWidth: 120,
      showOverflowTooltip: true
    },
    { prop: 'pv', label: '访问次数(pv)', minWidth: 100 },
    { prop: 'uv', label: '客户数量(uv)', minWidth: 100 },
    { prop: 'ip', label: 'IP数量', minWidth: 90 },
    {
      prop: 'duration',
      label: '访问总时长',
      minWidth: 120,
      formatter: (row) => secondToString(row.duration)
    },
    {
      prop: 'continueAttendNum',
      label: '持续听课三天以上且未成交的客户',
      minWidth: 220
    }
  ]
